import React from "react";
import { useResources } from "../../hooks/useResources";
import "./DeleteModal.scss";
import { Modal } from "./Modal";

export interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  isLoading?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  isLoading = false,
}) => {
  const { getResourceValue } = useResources();

  const defaultTitle = getResourceValue("delete_question", "Delete Question");
  const defaultMessage = getResourceValue(
    "confirm_delete_question",
    "Are you sure you want to delete this question? "
  );
  const defaultConfirmText = getResourceValue("delete", "Delete");
  const defaultCancelText = getResourceValue("cancel", "Cancel");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="delete-modal small-modal"
      showCloseButton={false}
    >
      <div className="delete-modal__content">
        <div className="delete-modal__icon-container">
          <div className="delete-modal__oval">
            <div className="delete-modal__icon-bg">
              <i className="f-icon trash-icon fa-solid"></i>
            </div>
          </div>
        </div>

        <div className="delete-modal__text">
          <h3 className="delete-modal__title">{title || defaultTitle}</h3>
          <p className="delete-modal__message">{message || defaultMessage}</p>
        </div>

        <div className="delete-modal__actions">
          <button
            type="button"
            className="delete-modal__confirm-btn"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {confirmButtonText || defaultConfirmText}
          </button>
          <button
            type="button"
            className="delete-modal__cancel-btn"
            onClick={onClose}
            disabled={isLoading}
          >
            {cancelButtonText || defaultCancelText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
